import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseRepository} from "./base/base.repository";

@Injectable({
  providedIn: 'root'
})
export class DashboardMessageRepository extends BaseRepository{
  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.path = 'dashboard/admin/dashboard-message';
  }
}
